<template>
  <div class="page-list__container">
    <div class="left-arrow" :class="productStore.currentPage == 1 ? 'disabled' : ''">
      <div class="arrow__inner"
        @click="productStore.currentPage > 1 ? $emit('changePage', productStore.currentPage - 1) : ''">
        <div class="icon-angle-left-before"></div>
      </div>
    </div>
    <div class="page-list__item" v-if="displayRangeStart > 1" @click="$emit('changePage', 1)">
      <div class="page-list__item--inner" :class="{ 'active': 1 == productStore.currentPage }">
        1
      </div>
    </div>
    <div class="page-list__item " v-if="hasLessPages">
      <div class="page-list__item--inner placeholder-dots">
        ...
      </div>
    </div>
    <div class="page-list__item" v-for="page in pages" :key="page" @click="$emit('changePage', page)">
      <div class="page-list__item--inner" :class="{ 'active': page == productStore.currentPage }">
        {{ page }}
      </div>
    </div>
    <div class="page-list__item " v-if="hasMorePages">
      <div class="page-list__item--inner placeholder-dots">
        ...
      </div>
    </div>
    <div class="page-list__item" v-if="displayRangeEnd < totalPages" @click="$emit('changePage', totalPages)">
      <div class="page-list__item--inner" :class="{ 'active': totalPages == productStore.currentPage }">
        {{ totalPages }}
      </div>
    </div>
    <div class="right-arrow" :class="productStore.currentPage == totalPages ? 'disabled' : ''">
      <div class="arrow__inner"
        @click="productStore.currentPage < totalPages ? $emit('changePage', productStore.currentPage + 1) : ''">
        <div class="icon-angle-right-before"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { useProductsStore } from '@/stores/products'
import { computed, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'

export default {
  name: "pageList",
  setup () {
    const maximumNumberOfLinks = 3
    const displayRangeStart = ref(1)
    const displayRangeEnd = ref(1)
    const productStore = useProductsStore()
    const { currentPage, perPage } = storeToRefs(productStore)

    const totalPages = computed(() => {
      return Math.max(1, Math.ceil(productStore.modelCounts / perPage.value))
    })
    const hasMorePages = computed(() => {
      return displayRangeEnd.value + 1 < totalPages.value
    })
    const hasLessPages = computed(() => {
      return displayRangeStart.value > 2
    })
    const maxNumLinks = computed(() => {
      if (maximumNumberOfLinks > totalPages.value) {
        return totalPages.value
      }
      return maximumNumberOfLinks
    })
    const delta = computed(() => {
      return Math.floor(maxNumLinks.value / 2)
    })

    function calcDisplayRange(page)
    {
      displayRangeStart.value = page - delta.value
      displayRangeEnd.value = page + delta.value - (maxNumLinks.value % 2 === 0 ? 1 : 0)
      if (displayRangeStart.value < 1) {
        displayRangeEnd.value -= displayRangeStart.value - 1
      }
      if (displayRangeEnd.value > totalPages.value) {
        displayRangeStart.value -= displayRangeEnd.value - totalPages.value
      }
      displayRangeStart.value = Math.max(displayRangeStart.value, 1)
      displayRangeEnd.value = Math.min(displayRangeEnd.value, totalPages.value)
    }

    watch(currentPage, (newVal) => calcDisplayRange(newVal))
    calcDisplayRange(currentPage.value)

    const pages = computed(() => {
      let pages = []
      for (let i = displayRangeStart.value; i <= displayRangeEnd.value; i++) {
        pages.push(i)
      }
      return pages
    })

    return { hasMorePages, hasLessPages, pages, displayRangeStart, displayRangeEnd, productStore, totalPages }
  },
}
</script>
